module.exports = __webpack_public_path__ + "static/media/gates2.96cad4b2.gif";